import React, { useEffect } from 'react'
import { Button, Grid, Typography } from '@mui/material'
import { NavLink } from 'react-router-dom'

import { APP_ROUTES } from '../constants.ts'
import { userActions } from '@/stores/slices/user-slice.ts'
import { useGetUserInfo } from '@/services'
import { useAppDispatch } from '@/stores/hooks.ts'

export const NotFoundPage = (): React.ReactElement => {
  const dispatch = useAppDispatch()

  const { data: { data: user } = {}, isSuccess } = useGetUserInfo()

  useEffect(() => {
    if (isSuccess && user) {
      dispatch(userActions.setUser(user))
    }
  }, [isSuccess])

  return (
    <Grid
      container
      spacing={5}
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        width: '100%',
        minHeight: '65vh',
      }}
    >
      <Grid item>
        <Typography variant="infographic" color="secondary">
          404
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="h3" textAlign="center" mb={3}>
          Такой страницы не существует
        </Typography>
        <Typography textAlign="center">Вероятно, она была удалена, или вы набрали неверный адрес</Typography>
      </Grid>
      <Grid item>
        <Button component={NavLink} to={user?.id ? APP_ROUTES.SbpPayments : APP_ROUTES.Login}>
          На главную
        </Button>
      </Grid>
    </Grid>
  )
}
